import { create } from 'zustand'

interface PhoneSelectionState {
  /** Whether the panel is in multi-select mode. */
  active: boolean
  /** Ids of the selected conversations. */
  selected: ReadonlySet<string>
  /** Enter select mode, optionally pre-selecting the triggering row. */
  enter: (id?: string) => void
  /** Leave select mode and clear the selection. */
  exit: () => void
  toggle: (id: string) => void
  selectAll: (ids: ReadonlyArray<string>) => void
  clear: () => void
}

const EMPTY: ReadonlySet<string> = new Set()

export const usePhoneSelection = create<PhoneSelectionState>((set) => ({
  active: false,
  selected: EMPTY,
  enter: (id) => set({ active: true, selected: id ? new Set([id]) : EMPTY }),
  exit: () => set({ active: false, selected: EMPTY }),
  toggle: (id) =>
    set((state) => {
      const next = new Set(state.selected)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return { selected: next }
    }),
  selectAll: (ids) => set({ selected: new Set(ids) }),
  clear: () => set({ selected: EMPTY }),
}))
